<template>
  <div>
    <!-- 列表 -->
    <el-table
      ref="multipleTable"
      border
      :data="listData"
      highlight-current-row
      style="width: 100%;"
      size="medium"
      header-row-class-name="table-header"
      @sort-change="sortChange"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column
        v-if="isEntrust"
        label="项目名称"
        prop="entrustProjectName"
        align="center"
        min-width="180"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="isEntrust"
        label="委托方"
        prop="entrustPurchaseCompanyName"
        align="center"
        min-width="180"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="isEntrust"
        label="负责人"
        prop="entrustUserName"
        align="center"
        min-width="120"
        show-overflow-tooltip
      />

      <el-table-column
        :label="`${bidCopyWriting.name}名称`"
        prop="orderName"
        align="center"
        min-width="200"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.orderName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="`${bidCopyWriting.name}编号`"
        prop="orderCode"
        align="center"
        min-width="130"
        show-overflow-tooltip=""
      >
        <template slot-scope="{ row }">
          <span>{{ row.orderCode || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="项目类型"
        prop="biddingType"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="{ row }">
          <span>
            {{ projectTypeDict.translate(row.biddingType).label || ' - ' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="发布人"
        prop="releasePeople"
        align="center"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.releasePeople || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="发布日期"
        prop="releaseTime"
        align="center"
        sortable="custom"
        min-width="180"
      >
        <template slot-scope="{ row }">
          <span>{{ row.releaseTime | getNormDayFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="是否电子化项目"
        prop="openTime"
        align="center"
        min-width="180"
      >
        <template slot-scope="{ row }">
          <span>
            {{ whetherDict.translate(row.isKpbProject).label || ' - ' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="开标时间"
        prop="openTime"
        align="center"
        sortable="custom"
        min-width="180"
      >
        <template slot-scope="{ row }">
          <span>{{ row.openTime | getNormMinuteFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isEntrust"
        label="代理服务费(元)"
        prop="agentServiceFee"
        align="center"
        show-overflow-tooltip
        min-width="140"
      >
        <template slot-scope="{ row }">
          <span>
            {{
              row.agentServiceFee
                ? `${strToThousands(row.agentServiceFee)}元`
                : '-'
            }}
          </span>
          <money-in-cn :money="row.agentServiceFee" />
        </template>
      </el-table-column>
      <el-table-column
        :label="`${bidCopyWriting.name}方式`"
        prop="biddingMethod"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="{ row }">
          <span>
            {{ getBiddingMethod(row) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" align="center" width="120">
        <template slot-scope="{ row }">
          <status-tag
            v-if="bidFlowStatusDict.translate(row.status)"
            :type="bidFlowStatusDict.translate(row.status).type"
            :label="bidFlowStatusDict.translate(row.status).label"
            size="small"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="参与供应商数量"
        prop="supplierNums"
        align="center"
        min-width="130"
      >
        <template slot-scope="{ row }">
          <span>{{ row.supplierNums || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-if="onlyLook"
            type="text"
            class="info-button"
            @click="handleLook(row)"
          >
            查看详情
          </el-button>

          <template v-else>
            <el-button
              v-if="hasPermission(row.status, 'edit')"
              type="text"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="hasPermission(row.status, 'del')"
              type="text"
              class="danger-button"
              @click="handleDelete(row)"
            >
              删除
            </el-button>
            <el-button
              v-if="hasPermission(row.status, 'copy')"
              type="text"
              @click="copyProject(row)"
            >
              复制项目
            </el-button>
            <el-button
              v-if="hasPermission(row.status, 'look')"
              type="text"
              class="info-button"
              @click="handleLook(row)"
            >
              查看详情
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      ref="pagination"
      :total="total"
      :page.sync="page"
      :limit.sync="size"
      @pagination="getListData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import StatusTag from '@/components/common/StatusTag.vue'
import MoneyInCn from '@/components/common/MoneyInCn'

import {
  bidInviteBidStatusDict,
  bidInviteWayDict,
  bidFlowStatusDict
} from '@/dictionary/project/bid'
import { kpbProjectStatusDict } from '@/dictionary/project/kpb-project'
import { projectTypeDict, whetherDict } from '@/dictionary/project/common'

import {
  deleteInviteBidApi,
  fetchInviteBidListApi
} from '@/api/procure/invite-bid'

import { strToThousands } from '@/utils/utils'
import { mapState } from 'vuex'

export default {
  name: 'InviteBidTable',

  components: {
    Pagination,
    StatusTag,
    MoneyInCn
  },

  props: {
    filterForm: {
      type: Object,
      default: () => {}
    },

    onlyLook: {
      type: Boolean,
      default: false
    },

    fetchApi: {
      type: Function,
      default: fetchInviteBidListApi
    },

    // 是否是委托项目
    isEntrust: {
      type: Boolean,
      default: false
    },

    pageNum: {
      type: [String, Number],
      default: 1
    },

    pageSize: {
      type: [String, Number],
      default: 10
    }
  },

  data() {
    return {
      projectTypeDict,
      bidInviteBidStatusDict,
      bidFlowStatusDict,
      bidInviteWayDict,
      whetherDict,

      total: 0,
      // 列表数据
      listData: []
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    isMerchant() {
      return this.$route.name.includes('Merchant')
    },

    // 是否为单一来源项目
    isSingleSource() {
      return this.$route.name.includes('Source')
    },

    // 招标名称
    bidCopyWriting() {
      if (this.isMerchant) return { name: '招商', fullName: '招商引资' }
      return { name: '招标', fullName: '招标采购' }
    },

    page: {
      get() {
        return this.pageNum
      },
      set(val) {
        this.$emit('update:pageNum', val)
      }
    },

    size: {
      get() {
        return this.pageSize
      },
      set(val) {
        this.$emit('update:pageSize', val)
      }
    },

    hasPermission() {
      return (status, buttonType) => {
        if (!bidFlowStatusDict.translate(status)) return false

        const operateList = bidFlowStatusDict.translate(status).permission

        return operateList.includes(buttonType)
      }
    },

    // 路由前缀
    routerPrefix() {
      const firstWord = (
        this.$route.name?.replace(/([A-Z])/g, $0 => `-${$0}`)?.split('-') || []
      ).filter(v => v)[0]

      if (firstWord === 'Bidding') return ''
      else return firstWord || ''
    }
  },

  activated() {
    this.getListData()
  },

  methods: {
    strToThousands,
    /**
     * 获取招标列表数据
     */
    getListData() {
      const requestParams = Object.assign(
        {},
        {
          page: this.page,
          size: this.size
        },
        this.filterForm,
        this.isSingleSource
          ? { biddingMethod: bidInviteWayDict.SINGLE_SOURCE.value }
          : {}
      )
      if (this.isMerchant) {
        requestParams.isMerchant = 1
      }
      this.fetchApi(requestParams)
        .then(res => {
          this.listData = res.data.records || []
          this.total = res.data.total || 0

          // 如果当前页没数据且总数据量大于0，则要页码-1后重新发起请求
          if (res.data.records.length === 0 && res.data.total > 0) {
            this.$refs.pagination.handleCurrentChange(this.page--)
          }
        })
        .catch(err => {
          this.$message.error(err.message || '获取列表失败')
        })
    },

    /**
     * 编辑操作
     */
    handleEdit(row) {
      this.$router.push({
        name: this.routerPrefix + 'BiddingForm',
        params: {
          orderId: row.orderId,
          projectId: row.projectId
        }
      })
    },

    /**
     * 删除操作
     */
    handleDelete(row) {
      const orderId = row.orderId
      const inviteBidName = row.orderName
      const _inviteBidName = inviteBidName ? `“${inviteBidName}”的` : ''
      this.$confirm(`删除${_inviteBidName}招标`, '删除招标', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteInviteBidApi({ orderId, isPublish: 0 })
            .then(res => {
              this.$message.success(res.message || '删除成功')
              this.getListData()
            })
            .catch(err => {
              this.$message.error(err.message || '删除失败')
            })
        })
        .catch(() => {})
    },

    /**
     * 查看详情操作
     */
    handleLook(row) {
      let routerName = ''
      if (row.orderFlowStatus) {
        routerName = bidFlowStatusDict.translate(row.orderFlowStatus).routerName
      } else {
        routerName = bidFlowStatusDict.translate(row.status).routerName
      }

      const status = row.orderFlowStatus || row.status
      if (Number(status) === bidFlowStatusDict.REGISTER_CLOSED.value) {
        if (row.bidOpened) {
          // 当报名已经截止，且未到开标时间时候，跳转到报名已截止页面
          // 到了开标时间后，跳转到候选人页面
          routerName = 'BiddingCandidate'
        }

        // 如果是线上开评标项目，则在报名已截止后，需要判断开评标项目状态进行跳转
        if (row.kpbProjectId) {
          if (row.kpbProjectStatus >= kpbProjectStatusDict.PUBLISHED.value) {
            routerName = 'BiddingOpenStep'
          }
          if (
            row.kpbProjectStatus >=
            kpbProjectStatusDict.EVALUATION_STARTED.value
          ) {
            routerName = 'BiddingReviewStep'
          }
        }
      }

      // 委托情况下，采购人只能查看委托，而代理机构可以编辑
      if (routerName === 'BiddingForm' && this.onlyLook) {
        routerName = 'BiddingInfo'
      }

      this.$router.push({
        name: this.routerPrefix + routerName,
        params: { orderId: row.orderId }
      })
    },

    /**
     * 复制项目
     */
    copyProject(row) {
      this.$confirm(`复制 “${row.orderName}” 的招标信息`, '复制项目', {
        confirmButtonText: '确定复制',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$router.push({
          name: this.routerPrefix + 'BiddingForm',
          params: {
            orderId: row.orderId,
            projectId: row.projectId,
            isCopy: true
          }
        })
      })
    },

    /**
     * 按顺序排序
     */
    sortChange(column, prop, order) {
      this.filterForm.sortBy = column.prop
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase()
      if (column.order == 'ascending') {
        this.filterForm.sortType = 'asc'
      } else if (column.order == 'descending') {
        this.filterForm.sortType = 'desc'
      } else {
        this.filterForm.sortType = undefined
      }
      this.getListData()
    },

    getBiddingMethod(row) {
      return (
        bidInviteWayDict
          .translate(row.biddingMethod)
          .label.replace(/招标/, this.bidCopyWriting.name) || ' - '
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
